module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.6d2fb5d9.svg";